var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactsEmty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5715 8.01083C12.291 8.01113 12.9878 7.75916 13.5406 7.29874C14.0935 6.83833 14.4674 6.19864 14.5973 5.491C14.7271 4.78336 14.6048 4.05258 14.2515 3.42585C13.8982 2.79912 13.3363 2.31612 12.6636 2.06091",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.39708 7.40073C7.28093 7.40073 8.12858 7.04962 8.75356 6.42464C9.37854 5.79967 9.72965 4.95201 9.72965 4.06816C9.72965 3.18431 9.37854 2.33666 8.75356 1.71168C8.12858 1.0867 7.28093 0.735596 6.39708 0.735596C5.51323 0.735596 4.66558 1.0867 4.0406 1.71168C3.41562 2.33666 3.06451 3.18431 3.06451 4.06816C3.06451 4.95201 3.41562 5.79967 4.0406 6.42464C4.66558 7.04962 5.51323 7.40073 6.39708 7.40073V7.40073Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5038 12.0843C13.1341 13.17 12.0331 15.2631 10.0733 15.2631H2.71859C0.76007 15.2631 -0.340958 13.17 1.28944 12.0843C2.80189 11.0761 4.57955 10.5395 6.39724 10.5424C8.28526 10.5424 10.0413 11.1102 11.5038 12.0843Z",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79004 15.2643H14.4531C16.2603 15.2643 17.2755 13.3314 15.772 12.3291C15.354 12.0513 14.9122 11.8111 14.4518 11.6113",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactsEmty);
export default __webpack_public_path__ + "static/media/contacts-emty.e72c5003025f50d4e6ff5fcfb277a5ff.svg";
export { ForwardRef as ReactComponent };